import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { groupCommodities, MobileDeliveryCommodityProduct } from './util';

class MobileDeliveryCommodities extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { commodities, classes, stopNumber } = this.props;
		if (!commodities) {
			return null;
		}
		const commodityInfo = groupCommodities({ commodities, stopNumber });
		const { hasMultipleDrops, commoditiesByStop } = commodityInfo;
		return (
			<>
				<div className={classes.productTitle}>Products</div>
				<div className={classes.productContainer}>
					{commoditiesByStop.map(({ stopSequence, commodities, consigneeId }) => {
						return (
							<div classes={classes.productStopGrouping} key={stopSequence}>
								{hasMultipleDrops && (
									<div className={classes.productStopTitle}>
										For Stop #{stopSequence} ({consigneeId})
									</div>
								)}
								<div className={hasMultipleDrops ? classes.productStopGrouping : null}>
									{commodities.map((commodity) => {
										return this.renderCommodity({ commodity });
									})}
								</div>
							</div>
						);
					})}
				</div>
			</>
		);
	}

	renderCommodity = ({ commodity }) => {
		const { classes } = this.props;

		const key = `${commodity.cmdCode}_${commodity.freightOrderedVolume}`;
		return (
			<div className={classes.product} key={key}>
				<div>
					<MobileDeliveryCommodityProduct cmdCode={commodity.cmdCode} />
					<strong>({commodity.freightOrderedVolume})</strong> gal of {commodity.cmdName}
				</div>

				<div className={classes.productAttributes}>
					{!!commodity.pin && (
						<span className={classes.productAttribute}>
							<span className={classes.tickerLabel}>Loading #: </span>
							<span>{commodity.pin}</span>
						</span>
					)}

					<span className={classes.productAttribute}>
						<span className={classes.tickerLabel}>Supplier: </span>
						<span>{commodity.freightSupplierId}</span>
					</span>
				</div>
			</div>
		);
	};
}

MobileDeliveryCommodities.propTypes = {
	classes: PropTypes.object.isRequired,
	commodities: PropTypes.array,
};

export default MobileDeliveryCommodities;
